import React from "react"
import PropTypes from "prop-types"


import GasSafeLogo from "../../../images/accreditations/Gas-Safe-Logo.svg"
import WACLogo from "../../../images/accreditations/Worcester-Accredited-Installer-Logo.svg"

export const Accreditations = ({ FCAIncluded }) => (
  <ul className="accreditations">
    <li>
      <GasSafeLogo />
    </li>
    <li>
      <WACLogo />
    </li>
  </ul>
)

Accreditations.defaultProps = {
  FCAIncluded: true,
}

Accreditations.propTypes = {
  FCAIncluded: PropTypes.bool,
}
